import commonMapping from "@/mapping/common";

const mul_session_type_list = [
  { id: "session1", value: "session1", config: "session1", label: "mul_session1" },
  { id: "session2", value: "session2", config: "session2", label: "mul_session2" },
];

export const schedule = {
  mul_session_type: mul_session_type_list,
  everyday: commonMapping.intToBoolean,
  sun: commonMapping.intToBoolean,
  mon: commonMapping.intToBoolean,
  tue: commonMapping.intToBoolean,
  wed: commonMapping.intToBoolean,
  thu: commonMapping.intToBoolean,
  fri: commonMapping.intToBoolean,
  sat: commonMapping.intToBoolean,
  all_day: commonMapping.intToBoolean,
};

export default schedule;
